export const externalAppType =
{
  zabka: "zabka",
  zabkaapp: "zabkaapp",
  lagardere: "lagardereapp",
}
